import { hover } from 'pobble-components/dist/jss-mixins'

const styles = ({ COLORS }) => ({
  center: {
    textAlign: 'center'
  },
  right: {
    textAlign: 'right'
  },
  groupWrapper: {
    cursor: 'pointer',
    transition: 'color, 0.3s',
    ...hover({
      color: COLORS.BLUE.NORMAL
    }),
    display: 'flex',
    alignItems: 'center'
  },
  spinner: {
    fontSize: '20px !important',
    margin: '8px 10px',
    display: 'inline-flex !important'
  },
  pendingRow: {
    '& td': {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
      }
    }
  },
  misLabel: {
    background: '#c5c5c5',
    display: 'block',
    borderRadius: '4px',
    fontSize: '11px',
    lineHeight: '12px',
    color: '#fff',
    padding: '2px 7px',
    marginLeft: '6px'
  },
  mis: {
    width: '40px',
    height: '40px',
    background: '#c5c5c5',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    fontSize: '11px',
    lineHeight: '12px',
    color: '#fff'
  }
})

export default styles
